import { get } from 'lodash';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../grid';
import { colors } from '../../../constants';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const FilterCheckbox = ({ name, label, subtitle, optionValues, iconName, onChecked, isFirst }) => {
  const [field, meta, helpers] = useField({ name, type: 'checkbox' });

  const setChecked = checked => {
    if (checked) {
      helpers.setValue(get(optionValues, 'on', checked));
      onChecked(name);
    } else {
      helpers.setValue(get(optionValues, 'off', checked));
    }
  };

  const { value } = meta;
  const checked = value !== optionValues.off;

  return (
    <Clickable
      py="14px"
      as="label"
      htmlFor={name}
      alignItems="start"
      borderTop={isFirst ? `1px solid ${colors.warmWhite3}` : 'none'}
      borderBottom={`1px solid ${colors.warmWhite3}`}
    >
      <HiddenCheckboxInput
        {...field}
        id={name}
        type="checkbox"
        checked={checked}
        onChange={event => setChecked(event.target.checked)}
      />
      <CheckboxVisual mt="2px" checked={checked}>
        {checked && <Icon name="tick" fill="white" height="24px" width="24px" />}
      </CheckboxVisual>
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        <Flex flexDirection="column" justifyContent="center">
          {label && (
            <P as="span" variant="standard-semi-bold">
              {label}
            </P>
          )}
          {subtitle && (
            <P as="span" color="grey70" mt="2px" variant="small">
              {subtitle}
            </P>
          )}
        </Flex>

        {iconName && (
          <Box as="span" ml={{ xs: '20px', lg: '45px' }} display="block">
            <Icon name={iconName} height="40px" width="40px" />
          </Box>
        )}
      </Flex>
    </Clickable>
  );
};

const CheckboxVisual = styled(Flex)`
  margin-right: 16px;
  height: 24px;
  width: 24px;
  min-width: 24px;
  border-radius: 4px;
  border: 2px solid black;
  background-color: ${({ checked }) => (checked ? 'black' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HiddenCheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const Clickable = styled(Flex)`
  cursor: pointer;
`;

FilterCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  optionValues: PropTypes.shape({ on: PropTypes.string, off: PropTypes.string }).isRequired,
  subtitle: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  onChecked: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
};

FilterCheckbox.defaultProps = {
  label: null,
  subtitle: null,
  isFirst: false,
};

export { FilterCheckbox };
